// extracted by mini-css-extract-plugin
export default {"logo":"m78spP","path":"_6eAZll"};